import { browserStorageGet } from '@/utils/browserStorage';
import BROWSER_STORAGE_KEYS from '@/constants/browserStorageKeys';
import { LANGUAGE } from '@/constants/common';
import { Language } from '@/types/common';

function getLanguage(): Language {
  return (browserStorageGet(BROWSER_STORAGE_KEYS.LANGUAGE) || LANGUAGE.EN) as Language;
}
export default getLanguage;
